(function () {
  var selector = '.single-option-radio input[data-product-option-selector]';

  function highlight(input) {
    var label = input.nextElementSibling;

    if (label && label.tagName === 'LABEL') {
      label.classList.add('cw-force-checked');
    }
  }

  function syncFromAttributes() {
    document.querySelectorAll(selector + '[checked]').forEach(highlight);
  }

  function syncFromVariant(variant) {
    if (!variant) {
      return;
    }

    [1, 2, 3].forEach(function (position) {
      var value = variant['option' + position];

      if (!value) {
        return;
      }

      document.querySelectorAll(selector + '[data-index="option' + position + '"]').forEach(function (input) {
        var label = input.nextElementSibling;

        if (!label || label.tagName !== 'LABEL') {
          return;
        }

        label.classList.toggle('cw-force-checked', input.value === value);
      });
    });
  }

  function syncMasterSelects(variant) {
    if (!variant) {
      return;
    }

    document.querySelectorAll('[data-product-master-select]').forEach(function (select) {
      select.value = variant.id;
    });
  }

  function mirrorInput(input) {
    var index = input.getAttribute('data-index');
    var value = input.value;

    if (!index) {
      return;
    }

    document.querySelectorAll('[data-product-option-selector][data-index="' + index + '"]').forEach(function (other) {
      if (other === input) {
        return;
      }

      if (other.tagName === 'SELECT') {
        other.value = value;
      } else if (other.getAttribute('type') === 'radio') {
        other.checked = other.value === value;
      }
    });
  }

  syncFromAttributes();

  document.addEventListener('change', function (event) {
    var input = event.target;

    if (input.matches && input.matches('[data-product-option-selector]')) {
      mirrorInput(input);
    }
  }, true);

  document.addEventListener('variantChange', function (event) {
    var variant = event.detail && event.detail.variant;

    syncFromVariant(variant);
    syncMasterSelects(variant);
  }, true);
})();
